import { Check, Sparkles, CalendarDays } from "lucide-react";
import { plansData } from "../../../utils/dummydata";
import { theme } from "../../../utils/theme";

const planMap = {
    printShop: plansData.printShop,
    supplier: plansData.suppliers,
    specialist: plansData.specialist,
};

const CurrentPlanCard = ({
    userType, // printShop | supplier | specialist
    status,
    nextBillingDate,
}) => {
    const plan = planMap[userType] || plansData.printShop; // Default to printShop if userType is not recognized
    const t = theme[userType];

    const isActive = status === true;

    return (
        <div
            className="bg-white rounded-[16px] border-2 overflow-hidden mb-[20px]"
            style={{ borderColor: t.primary }}
        >
            {/* HEADER */}
            <div
                className="px-[16px] py-[8px] flex items-center justify-between"
                style={{ backgroundColor: t.primary }}
            >
                <div className="flex items-center gap-[6px]">
                    <Sparkles className="w-[14px] h-[14px] text-white" />
                    <span className="font-semibold text-[12px] text-white uppercase tracking-[0.5px]">
                        Current Plan
                    </span>
                </div>

                <span className="font-semibold text-[12px] text-white/80">
                    {isActive ? "Active" : "Inactive"}
                </span>
            </div>

            {/* BODY */}
            <div className="p-[24px]">
                {/* PLAN HEADER */}
                <div className="flex items-start justify-between mb-[16px]">
                    <div>
                        <h3 className="font-semibold text-[20px] text-[#212326] mb-[2px]">
                            {plan.title}
                        </h3>

                        <div className="flex items-baseline gap-[4px]">
                            <span className="font-semibold text-[28px] text-[#212326]">
                                {plan.price}
                            </span>
                            <span className="font-medium text-[14px] text-[#717182]">
                                /month
                            </span>
                        </div>
                    </div>


                    <div className="flex items-center gap-[6px] bg-[#e8f8e8] rounded-[8px] px-[10px] py-[5px]">
                        <Check className="w-[12px] h-[12px] text-[#2ecc71]" />
                        <span className="font-semibold text-[11px] text-[#2ecc71]">
                            {status ? "Active" : "Inactive"}
                        </span>
                    </div>


                </div>

                {/* FEATURES */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-[10px] mb-[20px]">
                    {plan.features.map((feature, index) => (
                        <div key={index} className="flex items-center gap-[8px]">
                            <div
                                className="w-[18px] h-[18px] rounded-full flex items-center justify-center shrink-0"
                                style={{ backgroundColor: t.primary }}
                            >
                                <Check className="w-[10px] h-[10px] text-white" />
                            </div>

                            <span className="font-medium text-[13px] text-[#212326]">
                                {feature}
                            </span>
                        </div>
                    ))}
                </div>

                {/* FOOTER */}
                <div
                    className="flex items-center gap-[6px] rounded-[10px] px-[12px] py-[8px]"
                    style={{ backgroundColor: t.accentBg }}
                >
                    <CalendarDays
                        className="w-[14px] h-[14px]"
                        style={{ color: t.primary }}
                    />

                    <span
                        className="font-medium text-[12px]"
                        style={{ color: t.primary }}
                    >
                        Next billing date: {nextBillingDate}
                    </span>
                </div>
            </div>
        </div>
    );
};

export default CurrentPlanCard;